import { useIsThemedAppearance } from '../../../../shared/user-preferences/hooks/useIsThemedAppearance';
import styles from './parameters-section-title.module.css';

/**
 * "Parameters" section label above the entity-step cards. The v1.1 mocks add
 * this label; the legacy appearance never had one, so it renders in themed
 * (light/dark) mode only to keep legacy byte-identical.
 */
export const ParametersSectionTitle = () => {
  const isThemedAppearance = useIsThemedAppearance();

  if (!isThemedAppearance) {
    return null;
  }

  return <h3 className={styles.title}>Parameters</h3>;
};
